export enum MissionType {
  WEEKLY = "WEEKLY",
  MONTHLY = "MONTHLY",
  DAILY = "DAILY",
  TIMEBOUND = "TIMEBOUND",
}

export enum ProductCategoryEnum {
  AdventureMapWith_5Quests = "ADVENTURE_MAP_WITH_5_QUESTS",
  AdventureMapWith_10Quests = "ADVENTURE_MAP_WITH_10_QUESTS",
  AdventureMapWith_15Quests = "ADVENTURE_MAP_WITH_15_QUESTS",
  AdventureMapWith_20Quests = "ADVENTURE_MAP_WITH_20_QUESTS",
  AdventureMapWith_25Quests = "ADVENTURE_MAP_WITH_25_QUESTS",
  AdventureMapWith_30Quests = "ADVENTURE_MAP_WITH_30_QUESTS",
  DailyCalendar = "DAILY_CALENDAR",
  DailyMission = "DAILY_MISSION",
  HourlyMission = "HOURLY_MISSION",
  Matrix_2X_2 = "MATRIX_2_X_2",
  Matrix_3X_3 = "MATRIX_3_X_3",
  Matrix_4X_4 = "MATRIX_4_X_4",
  MonthlyMission = "MONTHLY_MISSION",
  Nba = "NBA",
  None = "NONE",
  Quiz = "QUIZ",
  Soccer = "SOCCER",
  WeeklyMission = "WEEKLY_MISSION",
  LeaderboardCumulative = "LEADERBOARD_CUMULATIVE",
  LeaderboardHighestMultiplier = "LEADERBOARD_HIGHEST_MULTIPLIER",
  Wheel_4_Section = "WHEEL_4_SECTION",
  Wheel_6_Section = "WHEEL_6_SECTION",
  Wheel_8_Section = "WHEEL_8_SECTION",
  Wheel_10_Section = "WHEEL_10_SECTION",
  Wheel_12_Section = "WHEEL_12_SECTION",
  Mystery_Box = "MYSTERY_BOX",
  Card_Matching_3_Rewards = "CARD_MATCHING_3_REWARDS",
  Card_Matching_4_Rewards = "CARD_MATCHING_4_REWARDS",
  Scratch_Game_3_Rewards = "SCRATCH_GAME_3_REWARDS",
  Multi_Wheel_4_Section = "MULTI_WHEEL_4_SECTION",
  Multi_Wheel_6_Section = "MULTI_WHEEL_6_SECTION",
  Multi_Wheel_8_Section = "MULTI_WHEEL_8_SECTION",
  Multi_Wheel_10_Section = "MULTI_WHEEL_10_SECTION",
  Multi_Wheel_12_Section = "MULTI_WHEEL_12_SECTION",
  UnlockableMission = "UNLOCKABLE_MISSION",
  CoinGathering = "COIN_GATHERING",
  BadgeEndless = "BADGE_ENDLESS",
  PenaltyRng = "PENALTY_RNG",
  Jackpot = "JACKPOT",
}

export enum TaskTypeEnum {
  Win_Count = "Win_count",
  Win_Amount = "Win_amount",
  Login = "Login",
  Deposit_Count = "Deposit_count",
  Deposit_Amount = "Deposit_amount",
  Win_Multiplier = "Win_multiplier",
  Spin = "Spin",
  Win_In_A_Row = "Win_in_a_row",
  Lose_In_A_Row = "Lose_in_a_row",
  Bet = "Bet",
  Kyc = "KYC",
  MiniGameBet = "MiniGameBet",
  Resigstration = "Registration",
  Sportsbet_amount = "Sportsbet_amount",
  Sportsbet_count = "Sportsbet_count",
  Settlement_amount = "Settlement_amount",
  Settlement_count = "Settlement_count",
  Settlement_multiplier = "Settlement_multiplier",
}

export enum QuestStatus {
  NoProgress = "NOPROGRESS",
  Completed = "COMPLETED",
  InProgress = "INPROGRESS",
}

export enum CasinoGameType {
  AdventureMap = "ADVENTURE_MAP",
  Matrix = "MATRIX",
  DailyOfferCalendar = "DAILY_OFFER_CALENDAR",
  Leaderboard = "LEADERBOARD",
  Wheel = "WHEEL",
  MysteryBox = "MYSTERY_BOX",
  CardMatching = "CARD_MATCHING",
  ScratchGame = "SCRATCH_GAME",
  MultiWheel = "MULTI_WHEEL",
  UnlockableMission = "UNLOCKABLE_MISSION",
  CoinGathering = "COIN_GATHERING",
  BadgeEndless = "BADGE_ENDLESS",
  Penalty = "PENALTY",
  Jackpot = "JACKPOT",
}
export enum RewardTypeEnum {
  Badges = "BADGES",
  BonusCash = "BONUS_CASH",
  Booster = "BOOSTER",
  Cash = "CASH",
  Currency = "CURRENCY",
  Empty = "EMPTY",
  FreeBetMulti = "FREE_BET_MULTI",
  FreeBetSingle = "FREE_BET_SINGLE",
  FreeSpinMulti = "FREE_SPIN_MULTI",
  FreeSpinSingle = "FREE_SPIN_SINGLE",
  FreeSpinInternal = "FREE_SPIN_INTERNAL",
  NoReward = "NO_REWARD",
  Offer = "OFFER",
  Other = "OTHER",
  Tangible = "TANGIBLE",
  Token = "TOKEN",
  VirtualCurrency = "VIRTUAL_CURRENCY",
  XpPoints = "XP_POINTS",
  CashbackFreeSpins = "CASHBACK_FREE_SPINS",
  CashbackCash = "CASHBACK_CASH",
  PromofyXp = "PROMOFY_XP",
  Xp = "XP",
  Symbol = "SYMBOL",
  LeaderboardPoint = "LEADERBOARD_POINT",
}

export enum RewardGroupEnum {
  GENERAL = "GENERAL",
  LEADERBOARD = "LEADERBOARD",
  UNLOCK = "UNLOCK",
}

export type RewardEntity = {
  casinoId?: number;
  id: number;
  organizationId: number;
  segmentId: number | null;
  typeId: number;
  name: string;
  createdAt: string;
  // name: {
  //   ru: string;
  //   en: string;
  //   ka: string;
  // };
  value: number;
  providerId: number | null;
  providerName: string | null;
  gameName: string | null;
  gameId: number | null;
  isoCode: string;
  symbol: string;
  multiplier: number | null;
  rewardType: RewardTypeEnum; // Include specific or more generic string if necessary
  rewardGroup?: RewardGroupEnum;
  probability: number;
  section: number;
  limit: number;
  image: string;
  minValue?: number | null;
  maxValue?: number | null;
  randomizerReward: [
    {
      sequence: number;
      limit: number;
      minCashBack: number;
      maxCashBack: number;
    },
  ];
};

export type CasinoPromoConfig = {
  countdown: boolean;
  id: number;
  name: string;
  slug: string | null;
  promoRef: string;
  categoryId: number;
  teaserDays: number;
  startDate: string; // ISO date string
  endDate: string; // ISO date string
  status: "ACTIVE" | "INACTIVE" | "EXPIRED" | string; // Temp values
  periodType: string | null;
  periodValue: string;
  participants: number;
  optIn: boolean;
  campaignAccess: "PUBLIC" | "PRIVATE" | "RESTRICTED" | string; // Temp values
  restrictedSegments: any[]; // any[] if the type of elements is unknown
  segments: any[]; // any[] if the type of elements is unknown
  segmentingStrategy?: "STATIC" | "DYNAMIC" | string;
  category: ProductCategoryEnum; // use union for known values
  questsUnlockStrategy: "PARALLEL" | "SEQUENTIAL" | string; // use union for known values
  quest: any[];
  questsSet: any[];
  infinite?: boolean;
  timezoneOffset: number;
  randomizerMilestones: string[];
  casinoReward: RewardEntity[];
  freeSpinAmount?: number;
  hasLeaderboard?: boolean;
  showStock?: boolean;
  autoPlay?: boolean;
  winnerCounterEnabled?: boolean;
  winnerCounterName?: string;
  winnerCounterPrizeAmount?: number;
  winnerCount?: number;
};

export type CasinoQuestProgress = {
  status: "INPROGRESS" | "COMPLETED" | "NOPROGRESS";
  currentProgress: number | null;
  maxProgress: number | null;
  needsClaiming: boolean;
  hasTaskAward: boolean;
};

export enum AwardStatusEnum {
  ISSUED = "ISSUED",
}
export enum StatussesEnum {
  UNCLAIMED = "UNCLAIMED",
  COMPLETED = "COMPLETED",
  CLAIMED = "CLAIMED",
  EXPIRED = "EXPIRED",
  FUTURE = "FUTURE",
  TODAY = "TODAY",
  PAST = "PAST",
}
